import { loader } from 'graphql.macro'

export default async function destroyJob ({ dataLoaders, variables }) {
  const schema = loader('./destroyJob.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      jobId: variables.jobId
    }
  })
  return response.destroyJob
}
